module.exports = __webpack_public_path__ + "img/3.4adc8f86.png";